module.exports = __webpack_public_path__ + "img/warranty.3b854ced.jpg";